import { createPageQueryDTOSchema } from '@tempo-io/common-dto';

const internalListSortableFields = ['id', 'createdAt', 'updatedAt'] as const;

export const internalListPageQueryDTOSchema = createPageQueryDTOSchema({
  sortableFields: internalListSortableFields,
  defaultSortBy: 'id',
});
